import { gql } from '@apollo/client';

export const GET_ORDER_TYPES = gql`
  query GET_ORDER_TYPES {
    getOrderTypes: getOrderTypesV5
  }
`;
